<script setup lang="ts">
defineEmits(["click"])
</script>

<template>
  <UButton
    class="sticky m-6 place-self-start justify-self-end bg-inherit"
    circle
    theme="white"
    variant="filled"
    aria-label="Lukk sidenotat"
    @click="$emit('click')"
  >
    <template #prepend>
      <UIcon
        name="close"
        size="xxs"
        class="m-1"
      />
    </template>
  </UButton>
</template>
